<template>
  <div>
    <div class="page_header">
      <span class="page_title">{{ $t('loginLog.loginLog') }}</span>
      <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
        <el-form-item :label="$t('vechiletype.Type') + '：'">
          <el-select v-model="form.QueryFlag" style="width: 120px;">
            <el-option :label="$t('public.all')" :value="0"></el-option>
            <!-- <template v-for="item in state"> -->
            <el-option v-for="i in state" :key="i.value" :label="i.label" :value="i.value"></el-option>
            <!-- </template> -->
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker v-model="date" type="daterange" align="right" style="width: 240px;"
            :range-separator="$t('time.to')" :picker-options="datePickerOptions"
            :start-placeholder="$t('time.startDate')" :end-placeholder="$t('time.endDate')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t("public.query") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="page_container">
      <el-table :data="tableData" :size="size" border style="width: 100%">
        <el-table-column :label='$t("public.OrderIndex")' type="index" align="center" width="105"></el-table-column>
        <el-table-column prop="OPTName" align="center" :label="$t('operlogq.OperatorName')"></el-table-column>
        <el-table-column prop="LogTime" align="center" :label="$t('maintenance.time')"></el-table-column>
        <el-table-column prop="LogType" align="center" :label="$t('vechiletype.Type')">
          <template slot-scope="scope">
            {{ scope.row.LogType == 1 ? $t('login.login_title') : $t('loginLog.loginOut') }}
          </template>
        </el-table-column>
        <el-table-column prop="ErrorFlag" align="center" :label="$t('state.title')">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.ErrorFlag == 0 ? 'green' : 'red' }">{{ scope.row.ErrorFlag == 0 ?
              $t('public.Success') : $t('public.Fail')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="LoginIP" align="center" :label="$t('loginLog.opeIP')"></el-table-column>

      </el-table>
    </div>
    <div style="text-align: right;margin-top:10px" class="pagination" v-show="total > 0"> <!--  -->
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="form.PageNo" :page-size="form.pageSize"
        layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "QueryLoginLog",
  components: {
  },
  computed: {
    size() {
      return this.$store.getters.size
    },
  },
  data() {
    return {
      form: {
        QueryFlag: 0,
        PageNo: 1,
        PageSize: 10,
      },
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date(new Date().getTime())
        }
      },
      state: [
        { label: this.$t('login.login_title'), value: 1 },
        { label: this.$t('loginLog.loginOut'), value: 2 },
      ],
      date: [new Date() - 6 * 24 * 60 * 60 * 1000, new Date()],
      loading: false,
      tableData: [],
      total: 0,
    }
  },
  methods: {
    handleCurrentChange(pageVal) {
      this.form.PageNo = pageVal;
      this.getData();
    },
    onSubmit() {
      this.form.BeginTime = this.moment(this.date[0]).format('YYYY-MM-DD 00:00:00')
      this.form.EndTime = this.moment(this.date[1]).format('YYYY-MM-DD 23:59:59')
      // console.log(this.form);
      this.form.PageNo = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.$api.QueryLoginLog(this.form).then((res) => {
        if (res && res.code == 200) {
          this.loading = false;
          this.tableData = res.data.data;
          this.total = res.data.recordsTotal;
        }
      })
        .catch(() => {
          this.loading = false;
          this.tableData = [];
          this.total = 0;
        });
    }
  },
  mounted() {
    this.form.OperatorID = this.$store.getters.operator.OperatorId;
    this.onSubmit();
  },

}
</script>
<style lang="scss" scoped>
.pagination {

  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }

}
</style>